import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';

import { ConfigurationService } from '../../configuration.service';
import { SessionService } from '../../session.service';
import { Session } from '../../session';
import { AppConst } from '../../app-const';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {

  // トップ画面
  readonly topLink = AppConst.ROUTING_LINK_TOP;
  // プロジェクト情報
  readonly projectLink = AppConst.ROUTING_LINK_PROJECT;
  // ファイルアップロード画面
  readonly uploaderLink = AppConst.ROUTING_LINK_UPLOADER;
  // ファイルアップロード画面
  readonly uploaderDLLink = AppConst.ROUTING_LINK_UPLOADER_DL;
  // SPLATS情報
  readonly splatsLink = AppConst.ROUTING_LINK_SPLATS;
  // 施設情報
  readonly facilityLink = AppConst.ROUTING_LINK_FACILITY;
  // 建物情報
  readonly hallLink = AppConst.ROUTING_LINK_HALL;
  // フロア情報
  readonly floorLink = AppConst.ROUTING_LINK_FLOOR;
  // 施設職員情報
  readonly facilityUserLink = AppConst.ROUTING_LINK_FACILITY_USER;
  // コンテンツ購入日次情報
  readonly purchaseContentDailyLink = AppConst.ROUTING_LINK_PURCHASE_CONTENT_DAILY;
  // 展示情報
  readonly exhibitLink = AppConst.ROUTING_LINK_EXHIBIT;
  // 展示詳細情報
  readonly exhibitDetailLink = AppConst.ROUTING_LINK_EXHIBIT_DETAIL;
  // ランキング情報
  readonly exhibitRankingLink = AppConst.ROUTING_LINK_EXHIBIT_RANKING;
  // 音声ファイルダウンロード
  readonly voiceFileDownloadLink = AppConst.ROUTING_LINK_VOICE_FILE_DOWNLOAD;
  // 施設属性情報
  readonly facilityAttributeLink = AppConst.ROUTING_LINK_FACILITY_ATTRIBUTE;
  // 展示属性情報
  readonly exhibitAttributeLink = AppConst.ROUTING_LINK_EXHIBIT_ATTRIBUTE;
  // 展示詳細属性情報
  readonly exhibitDetailAttributeLink = AppConst.ROUTING_LINK_EXHIBIT_DETAIL_ATTRIBUTE;
  // 予約設備属性情報
  readonly reservationFacilityAttributeLink = AppConst.ROUTING_LINK_RESERVATION_FACILITY_ATTRIBUTE;
  // アップロードファイル属性情報
  readonly uploadedFilesAttributeLink = AppConst.ROUTING_LINK_UPLOADED_FILES_ATTRIBUTE;
  // ユーザー情報
  readonly userLink = AppConst.ROUTING_LINK_USER;
  // 汎用テキスト情報
  readonly generalTextLink = AppConst.ROUTING_LINK_GENERAL_TEXT;
  // 言語情報
  readonly languageLink = AppConst.ROUTING_LINK_LANGUAGE;
  // 通知情報
  readonly noticeLink = AppConst.ROUTING_LINK_NOTICE;
  // QR生成
  readonly qrcodeLink = AppConst.ROUTING_LINK_QRCODE;
  // 予約設備
  readonly reservationFacilityLink = AppConst.ROUTING_LINK_RESERVATION_FACILITY;
  // 予約設問
  readonly reservationQuestionLink = AppConst.ROUTING_LINK_RESERVATION_QUESTION;
  // 予約状況
  readonly reservationLink = AppConst.ROUTING_LINK_RESERVATION;
  // 予約ダウンロード
  readonly reservationDownloadLink = AppConst.ROUTING_LINK_RESERVATION_DOWNLOAD;
  // 掲示板
  readonly boardThreadLink = AppConst.ROUTING_LINK_BOARD_THREAD;
  readonly boardCommentLink = AppConst.ROUTING_LINK_BOARD_COMMENT;
  // 設問情報
  readonly questionLink = AppConst.ROUTING_LINK_QUESTION;
  // 設問セット
  readonly questSetLink = AppConst.ROUTING_LINK_QUEST_SET;
  // 避難所情報
  readonly shelterLink = AppConst.ROUTING_LINK_SHELTER;
  // アンケートダウンロードファイル作成
  readonly enqueteLink = AppConst.ROUTING_LINK_ENQUETE;
  // 入退場管理：イベント情報
  readonly entranceExitEventLink = AppConst.ROUTING_LINK_ENTRANCE_EXIT_EVENT;
  // 入退場管理：スタッフ情報
  readonly entranceExitUserLink = AppConst.ROUTING_LINK_ENTRANCE_EXIT_USER;
  // 入退場管理：設問情報
  readonly entranceExitQuestionLink = AppConst.ROUTING_LINK_ENTRANCE_EXIT_QUESTION;
  // 入退場管理：エントリー情報
  readonly entranceExitEntryLink = AppConst.ROUTING_LINK_ENTRANCE_EXIT_ENTRY;
  // 入退場管理：日次入退場状況
  readonly entranceExitTransitDailyLink = AppConst.ROUTING_LINK_ENTRANCE_EXIT_TRANSIT_DAILY;
  // 入退場管理：展示来場状況ダウンロード
  entranceExitExhibitTransitDownloadLink = AppConst.ROUTING_LINK_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD;

  // 通知管理
  readonly noticeManageLink = AppConst.ROUTING_LINK_NOTICE_MANAGE;
  // マニュアル
  readonly manualLink = AppConst.ROUTING_LINK_MANUAL_INDEX;
  //ユーザータイプ
  readonly USER_TYPE_ADMIN: number = AppConst.MANAGE_USER_TYPE_ADMIN;
  readonly USER_TYPE_MASTER: number = AppConst.MANAGE_USER_TYPE_MASTER;
  readonly USER_TYPE_USER: number = AppConst.MANAGE_USER_TYPE_USER;

  subscription = new Subscription();

  isSignIn: boolean = false;
  userType!: number;
  projectId!: string;
  projectName:string = '';
  isProjectId: boolean = false;
  newNotices: boolean = false;
  private projectIdSubscription!: Subscription;
  current_language!: string ;
  
  constructor(
    private router: Router,
    private configurationService: ConfigurationService,
    private sessionService: SessionService,
    private clipboard: Clipboard,
    private translate: TranslateService
  ) {
    //日本語をデフォルト言語に設定
    this.translate.use('ja');
    // this.translate.setDefaultLang('');
    // localStorageからcurrent_languageを読み込む
    const savedLanguage = localStorage.getItem('current_language');
    if (savedLanguage) {
      this.current_language = savedLanguage;
      this.translate.use(this.current_language);
      this.sessionService.setCurrentLanguage(this.current_language);
    } else {
      // デフォルト言語を設定
      this.translate.use('ja');
      this.sessionService.setCurrentLanguage('ja');
    }
   }

  ngOnInit(): void {
    this.subscription.add(
      this.sessionService.sessionState.subscribe((session: Session)=> {
        if (session) {
          this.isSignIn = session.isLogin;
          this.userType = session.user ? session.user.user_type : 0;
          this.current_language = session.current_language;
          this.translate.use(this.current_language);
        }
      })
    );

    this.projectId = this.configurationService.getProjectId();
    this.projectIdSubscription = this.configurationService.projectIdSubject$.subscribe(
      projectIdChanged => {
        this.projectId = projectIdChanged;
        this.projectName = this.configurationService.getProjectName();
      }
    );

    this.configurationService.newNoticesSubject$.subscribe(newNotices => {
      this.newNotices = newNotices;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.projectIdSubscription.unsubscribe();
  }

  signOut() {
    this.configurationService.setProjectName('');
    this.configurationService.setProjectId('');
    this.sessionService.logout();
  }

  navigatedTop() {
    this.configurationService.setProjectName('');
    this.configurationService.setProjectId('');
    this.router.navigate([AppConst.ROUTING_TOP]);
  }

  copyClipboardQrreaderUrl(): void {
    const url = `${environment.qrBaseUrl}${this.configurationService.getProjectId()}`;
    this.clipboard.copy(url);
  }

}
